import { z } from 'zod';
import { BreakOption, EmploymentType, LocationAutoSuggestItem } from '@types';

const GetNotWelcomeListItem = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  imageUrl: z.string().optional(),
  infix: z.string(),
  reason: z.string(),
  dateAdded: z.string(),
  departments: z.array(z.string()),
  employmentType: z.nativeEnum(EmploymentType).optional(),
});

export const GetNotWelcomeListResponse = z.array(GetNotWelcomeListItem);

export type NotWelcomeListItem = z.infer<typeof GetNotWelcomeListItem>;

export enum WorkerType {
  FLEXWORKER = 'FLEXWORKER',
}

const GetFlexWorkerForNotWelcomeList = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  infix: z.string().optional().nullable(),
  email: z.string(),
  workerType: z.nativeEnum(WorkerType),
  employmentType: z.nativeEnum(EmploymentType).nullable(),
});

export const GetFlexWorkerForNotWelcomeListResponse = z.array(GetFlexWorkerForNotWelcomeList);
export type FlexWorkerForNotWelcomeList = z.infer<typeof GetFlexWorkerForNotWelcomeList>;

export type GetBreakOptionsResponse = {
  breakOptions: BreakOption[];
};

export type ChangeCompanySettingsPayload = {
  requiresEmployeeContract: boolean;
  requiresEmployeeCertificates: boolean;
  employeeMutableUntilMinutes: number;
  allowShiftStartTimeOverride: boolean;
  allowShiftEndTimeOverride: boolean;
  allowEditCheckoutHours: boolean;
};

export type CompanyThemeColors = {
  primaryColor: string;
  secondaryColor: string;
  primaryAccent: string;
  secondaryAccent: string;
};

export type CompanyThemeLogoFiles = {
  portalLogoWide?: File;
  portalLogoSquare?: File;
};

export type UpdateCompanyThemePayload = {
  colors: CompanyThemeColors;
  logo?: CompanyThemeLogoFiles;
};

export type CompanyInfoByCocNumber = {
  companyName: string;
  location: LimitedCompanyLocation;
};

export type LimitedCompanyLocation =
  | LocationAutoSuggestItem
  | {
      address: string;
      latitude?: number;
      longitude?: number;
      street?: string;
      houseNumber: string;
      postalCode: string;
      city?: string;
      country?: string;
      isVerified: boolean;
    };

export type CreateLimitedCompanyPayload = {
  cocNumber: string;
  companyName: string;
  location: LimitedCompanyLocation;
  invoiceEmail: string;
  profileImageUrl?: string;
  adminFirstName: string;
  adminLastName: string;
  adminEmail: string;
  adminPhone: string;
};

export type CreateLimitedCompanyResponse = {
  companyId: string;
  serviceAgreementId: string;
};
